import { useMemo } from "react";

import { WidgetContainer } from "@/lib/api";
import { WidgetContainerCard } from "@/features/dashboard/components";
import { WidgetGridLayout } from "@/features/shared/components";
import useLayoutStore from "@/store/useLayoutStore";

const WidgetGrid = ({ containers }: { containers: WidgetContainer[] }) => {
  const [isFullscreen] = useLayoutStore((s) => s.context.isFullscreen);

  const transformGridLayoutToLayout = (containers: WidgetContainer[], isMobile = false) => {
    return containers.map((item) => ({
      ...item,
      i: item.id,
      y: item.position_y,
      w: isMobile ? 12 : item.width,
      h: item.height,
      x: item.position_x,
      minW: item.min_width,
      minH: item.min_height,
    }));
  };

  // map the layour items into different breakpoints
  const layoutVerions = useMemo(
    () => ({
      lg: transformGridLayoutToLayout(containers),
      md: transformGridLayoutToLayout(containers),
      sm: transformGridLayoutToLayout(containers, true),
      xs: transformGridLayoutToLayout(containers, true),
      xxs: transformGridLayoutToLayout(containers, true),
    }),
    [containers],
  );

  return (
    <WidgetGridLayout
      useCSSTransforms={!isFullscreen}
      isResizable={false}
      isDraggable={false}
      layouts={layoutVerions}
      containerPadding={[20, 20]}
      style={{
        marginTop: "-20px",
        position: isFullscreen ? "static" : "relative",
        maxWidth: "100%",
      }}
    >
      {containers.map((container) => (
        <WidgetContainerCard key={container.id} container={container} />
      ))}
    </WidgetGridLayout>
  );
};

export default WidgetGrid;
